import { apiHolder, apis } from 'api';
import { MailActions } from '@web-common/state/createStore';
import { isMainAccount, folderIdIsContact, folderIdIsAllFolderSubAccount, folderIdIsAllFolder, parseFidFromAllFid, parseAllFolderSubAccount, parseAccountFromAllFolderSubAccount, folderIsUnread, folderIdIsAllUnreadFolder, getMailListByIdFromStore, getAllAccountsFromTmap, shouldSkipOpenNext, } from '../../../util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { FolderThunks } from './folderThunks';
import { MailListThunks } from './listThunk';
import { MailBoxThunks } from './mailboxThunks';
import { getRealCountFromAvtiveMails, getAccountByMailId, getFolderByMailId, getIsSearchingMailByState, getIsUseRealList, } from '../../customize';
import { FLOLDER, TASK_MAIL_STATUS } from '../../../common/constant';
import { reducerHelper } from '@web-mail/state/slice/mailReducer/helper';
import { getIn18Text } from 'api';
const mailApis = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const mailPlusCustomerApi = apiHolder.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const ReducerName = 'MailReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
const getUnreadFolderIdList = (mailTreeStateMap, accountId) => {
    var _a, _b, _c;
    const key = isMainAccount(accountId) ? 'main' : ((_a = systemApi.getCurrentUser(accountId)) === null || _a === void 0 ? void 0 : _a.agentEmail) || '';
    const map = (_b = mailTreeStateMap[key]) === null || _b === void 0 ? void 0 : _b.MailFolderTreeMap;
    const idList = [];
    for (let i in map) {
        let folder = map[i];
        const mailBoxId = folder === null || folder === void 0 ? void 0 : folder.mailBoxId;
        if (mailBoxId >= 0 && ((_c = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _c === void 0 ? void 0 : _c.mailBoxUnread) > 0 && !folder.entry.locked) {
            idList.push(mailBoxId);
        }
    }
    return idList;
};
thunkHelper({
    name: 'doActiveFolderAllRead',
    request: async (params, thunkAPI) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const { rejectWithValue, getState, dispatch } = thunkAPI;
        const { folderId, isThread = false, accountId } = params || {};
        const state = getState().mailReducer;
        const { selectedKeys, mailTreeStateMap, mailTagFolderActiveKey } = state;
        if (folderId == null) {
            reduxMessage.error({ content: getIn18Text('WEIQUEDINGSUOZAI') });
            return rejectWithValue();
        }
        try {
            let res;
            if (folderIsUnread(folderId)) {
                if (folderIdIsAllUnreadFolder(folderId)) {
                    if (folderId == FLOLDER.ALL_UNREAD) {
                        const originFolderId = parseFidFromAllFid(folderId);
                        const allAccounts = Object.values(state.mailTreeStateMap)
                            .filter(treeInfo => treeInfo && !treeInfo.expired)
                            .map(treeInfo => treeInfo.accountId);
                        for (const accountId of allAccounts) {
                            const key = isMainAccount(accountId) ? 'main' : ((_a = systemApi.getCurrentUser(accountId)) === null || _a === void 0 ? void 0 : _a.agentEmail) || '';
                            const mailTree = (_b = mailTreeStateMap[key]) === null || _b === void 0 ? void 0 : _b.MailFolderTreeMap;
                            const idList = Object.values(mailTree || {})
                                .filter(folder => {
                                const id = typeof folder.mailBoxId === 'string' ? parseInt(folder.mailBoxId) : folder.mailBoxId;
                                return folder && typeof id === 'number' && id >= 0 && folder.entry.mailBoxUnread > 0 && !folder.entry.locked;
                            })
                                .map(folder => {
                                if (typeof folder.mailBoxId === 'string') {
                                    const id = parseInt(folder.mailBoxId);
                                    if (!isNaN(id)) {
                                        return id;
                                    }
                                    return null;
                                }
                                return folder.mailBoxId;
                            })
                                .filter(id => id != null);
                            try {
                                const res = await mailApis.doMarkMailFolderRead(idList, isThread, ((_c = systemApi.getCurrentUser(accountId)) === null || _c === void 0 ? void 0 : _c.id) || '');
                            }
                            catch (e) {
                                console.error(`[doActiveFolderAllRead Error] originFolderId:${originFolderId} accountId:${accountId}`, e);
                            }
                        }
                    }
                    else {
                        const allAccounts = parseAccountFromAllFolderSubAccount(folderId);
                        const key = isMainAccount(allAccounts) ? 'main' : ((_d = systemApi.getCurrentUser(allAccounts)) === null || _d === void 0 ? void 0 : _d.agentEmail) || '';
                        let map = (_e = mailTreeStateMap[key]) === null || _e === void 0 ? void 0 : _e.MailFolderTreeMap;
                        const idList = Object.values(map || {})
                            .filter(folder => {
                            const id = typeof folder.mailBoxId === 'string' ? parseInt(folder.mailBoxId) : folder.mailBoxId;
                            return folder && typeof id === 'number' && id >= 0 && folder.entry.mailBoxUnread > 0 && !folder.entry.locked;
                        })
                            .map(folder => {
                            if (typeof folder.mailBoxId === 'string') {
                                const id = parseInt(folder.mailBoxId);
                                if (!isNaN(id)) {
                                    return id;
                                }
                                return null;
                            }
                            return folder.mailBoxId;
                        })
                            .filter(id => id != null);
                        try {
                            res = await mailApis.doMarkMailFolderRead(idList, isThread, ((_f = systemApi.getCurrentUser(allAccounts)) === null || _f === void 0 ? void 0 : _f.id) || allAccounts);
                        }
                        catch (e) {
                            console.error(`[doActiveFolderAllRead Error] originFolderId:${folderId} accountId:${allAccounts}`, e);
                        }
                    }
                }
                else {
                    const idList = getUnreadFolderIdList(state.mailTreeStateMap, accountId);
                    res = await mailApis.doMarkMailFolderRead(idList, isThread, ((_g = systemApi.getCurrentUser(accountId)) === null || _g === void 0 ? void 0 : _g.id) + '');
                }
            }
            else if (folderIdIsContact(folderId)) {
                res = await mailApis.doMarkStarMailAll(folderId);
            }
            else if (!folderIsUnread(folderId) && folderIdIsAllFolder(folderId)) {
                if (folderIdIsAllFolderSubAccount(folderId)) {
                    const allFolderId = parseAllFolderSubAccount(folderId);
                    const allAccounts = parseAccountFromAllFolderSubAccount(folderId);
                    if (allFolderId && allAccounts) {
                        const originFolderId = parseFidFromAllFid(allFolderId);
                        try {
                            res = await mailApis.doMarkMailInfFolder(true, parseInt(originFolderId + ''), false, ((_h = systemApi.getCurrentUser(allAccounts)) === null || _h === void 0 ? void 0 : _h.id) + '');
                        }
                        catch (e) {
                            console.error(`[doActiveFolderAllRead Error] originFolderId:${originFolderId} accountId:${allAccounts}`, e);
                        }
                    }
                }
                else {
                    const originFolderId = parseFidFromAllFid(folderId);
                    const allAccounts = [];
                    for (let i in state.mailTreeStateMap) {
                        const treeInfo = state.mailTreeStateMap[i];
                        if (treeInfo && !treeInfo.expired) {
                            allAccounts.push(treeInfo.accountId);
                        }
                    }
                    for (let i = 0; i < allAccounts.length; i++) {
                        const accountId = allAccounts[i];
                        try {
                            res = await mailApis.doMarkMailInfFolder(true, parseInt(originFolderId + ''), false, ((_j = systemApi.getCurrentUser(accountId)) === null || _j === void 0 ? void 0 : _j.id) + '');
                        }
                        catch (e) {
                            console.error(`[doActiveFolderAllRead Error] originFolderId:${originFolderId} accountId:${accountId}`, e);
                        }
                    }
                }
            }
            else if (folderId === FLOLDER.TAG && (mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key)) {
                const idList = getUnreadFolderIdList(state.mailTreeStateMap, accountId);
                res = await mailApis.doMarkMailTagRead(idList, mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key, isThread, accountId);
            }
            else {
                res = await mailApis.doMarkMailInfFolder(true, folderId, isThread, (_k = systemApi.getCurrentUser(accountId)) === null || _k === void 0 ? void 0 : _k.id);
            }
            if (res && res.succ) {
                if (selectedKeys.id == folderId) {
                    if (folderId === FLOLDER.TAG) {
                        dispatch(MailBoxThunks.requestTaglist({
                            account: accountId,
                        }));
                    }
                    dispatch(FolderThunks.refreshFolder({ noCache: true }));
                }
                return res;
            }
        }
        catch (err) {
            console.error('[doActiveFolderAllRead Error]', err);
            return rejectWithValue(err);
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg;
        const { folderId } = params || {};
        if (folderId == state.selectedKeys.id) {
            state.mailDataList.forEach(id => {
                const mail = state.mailEntities[id];
                if (mail) {
                    mail.entry.readStatus = 'read';
                }
            });
        }
    },
    rejected: (state) => {
        reduxMessage.error({ content: getIn18Text('BIAOJISHIBAI') });
    },
});
thunkHelper({
    name: 'doActiveFolderAllFollow',
    request: async (params, thunkAPI) => {
        const { rejectWithValue, getState, dispatch } = thunkAPI;
        const { account, customerEmail, isAll } = params || {};
        const state = getState().mailReducer;
        let accountList = [];
        if (isAll) {
            accountList = getAllAccountsFromTmap(state.mailTreeStateMap);
        }
        else {
            if (account) {
                accountList = account;
            }
        }
        try {
            const res = await mailPlusCustomerApi.doMarkAllProcessedOfFollow(accountList, customerEmail);
            return res;
        }
        catch (err) {
            console.error('[doActiveFolderAllRead Error]', err);
            return rejectWithValue(err);
        }
    },
    fulfilled: (state, action) => {
        reduxMessage.success({ content: getIn18Text('CAOZUOCHENGGQSHSXCK') });
    },
    rejected: (state) => {
        reduxMessage.error({ content: getIn18Text('BIAOJISHIBAI') });
    },
});
thunkHelper({
    name: 'doActiveAllReadDefer',
    request: async (params, thunkAPI) => {
        const { deferTime } = params || {};
        const { rejectWithValue, dispatch } = thunkAPI;
        try {
            const res = await mailApis.doMarkMailDeferAll(deferTime);
            if (res && res.succ) {
                reduxMessage.success({
                    content: getIn18Text('YICHULI'),
                });
                dispatch(FolderThunks.refreshFolder({ noCache: true }));
                return res;
            }
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    fulfilled: (state, action) => {
        var _a;
        const params = action.meta.arg;
        const { folderId } = params || {};
        if (folderId == state.selectedKeys.id && ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.succ)) {
            state.mailDataList.forEach((id, index) => {
                const mail = state.mailEntities[id];
                if (!mail.taskId) {
                    state.mailDataList.splice(index);
                }
            });
            state.mailTotal = 0;
        }
        else {
            reduxMessage.error({ content: getIn18Text('CAOZUOSHIBAI\uFF0C11') });
        }
    },
    rejected: (state) => {
        reduxMessage.error({ content: getIn18Text('CAOZUOSHIBAI\uFF0C11') });
    },
});
thunkHelper({
    name: 'deleteMailFromList',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { id, showLoading = true, directDelete } = params;
        const state = thunkAPI.getState().mailReducer;
        const fid = getFolderByMailId(state, id);
        if (!fid) {
            showLoading &&
                reduxMessage.error({
                    content: getIn18Text('WEIQUERENSUOZAI'),
                });
            return rejectWithValue();
        }
        try {
            const result = await mailApis.doDeleteMail({ fid, id, _account: getAccountByMailId(state, id), directDelete });
            return result;
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    pending: (state, action) => {
        state.commonModalVisible = false;
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const res = action.payload;
        const { id, showLoading = true } = params;
        const isDeletedFolder = state.selectedKeys.id === FLOLDER.DELETED;
        if (res.succ) {
            state.commonModalVisible = false;
            showLoading &&
                reduxMessage.success({
                    content: `邮件删除成功${isDeletedFolder ? '' : getIn18Text('\u3002KEZAI\u201CYI')}`,
                });
            state.mailDataList = state.mailDataList.filter(item => item !== id);
            state.searchList = state.searchList.filter(item => item !== id);
            state.activeIds = state.activeIds.filter(item => item !== id);
            state.mailRelateMailList = state.mailRelateMailList.filter(item => item !== id);
            state.mailRelateMailList = state.mailRelateMailList.filter(item => item !== id);
            state.mailRelateStrangeMailList = state.mailRelateStrangeMailList.filter(item => item !== id);
        }
    },
    rejected: (state, action) => {
        const error = action.payload;
        const { showLoading = true } = action.meta.arg || {};
        showLoading &&
            reduxMessage.error({
                content: getIn18Text('YOUJIANSHANCHUSHI'),
            });
        console.warn(error);
    },
});
thunkHelper({
    name: 'deleteMail',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { id, detail = false, showLoading = true, isScheduleSend = false, folderId, directDelete = false } = params || {};
        const state = thunkAPI.getState().mailReducer;
        const { selectedKeys } = state;
        const key = folderId ? folderId : selectedKeys.id;
        const isDeleted = key === 4 || directDelete;
        let result = null;
        if (typeof id === 'string' && !isDeleted && !detail && !isScheduleSend) {
            result = await dispatch(Thunks.deleteMailNoConfirm(params));
        }
        else {
            result = await dispatch(Thunks.deleteMailReConfirm(params));
        }
        return result;
    },
});
thunkHelper({
    name: 'deleteMailNoConfirm',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { id, showLoading = true, directDelete } = params || {};
        dispatch(MailActions.mailOperCheck(id));
        try {
            const result = await dispatch(Thunks.deleteMailFromList({
                id,
                showLoading: false,
                directDelete,
            })).unwrap();
            return result;
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { id, showLoading = true } = params || {};
        const messageKey = id === null || id === void 0 ? void 0 : id.toString();
        if (showLoading) {
            reduxMessage.loading({
                content: getIn18Text('YOUJIANSHANCHUZHONG'),
                duration: 30,
                key: messageKey,
            });
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const { id, showLoading = true, isScheduleSend = false, folderId, directDelete = false } = params || {};
        const res = action.payload;
        const { selectedKeys } = state;
        const key = selectedKeys ? selectedKeys.id : '';
        const messageKey = id === null || id === void 0 ? void 0 : id.toString();
        const folder = folderId ? folderId : state.selectedKeys.id;
        const isDeletedFolder = folder === FLOLDER.DELETED || directDelete;
        if (res && res.succ) {
            showLoading &&
                reduxMessage.success({
                    content: `邮件删除成功${isDeletedFolder ? '' : getIn18Text('\u3002KEZAI\u201CYI')}`,
                    duration: 2,
                    key: messageKey,
                });
        }
        else {
            showLoading && reduxMessage.error({ content: getIn18Text('YOUJIANSHANCHUSHI'), duration: 2, key: messageKey });
        }
    },
    rejected: (state, action) => {
        const error = action.payload;
        const params = action.meta.arg || {};
        const { id, showLoading = true, isScheduleSend = false } = params || {};
        const messageKey = id === null || id === void 0 ? void 0 : id.toString();
        reduxMessage.error({ content: getIn18Text('YOUJIANSHANCHUSHI'), duration: 2, key: messageKey });
        state.showGlobalLoading = false;
        console.warn(error);
    },
});
thunkHelper({
    name: 'deleteMailMultiAccount',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { map, isScheduleSend = false, fid, directDelete = false } = params || {};
        if (map) {
            let reqCount = 0;
            for (let i in map) {
                const idList = map[i];
                try {
                    console.log(4444, 'doDeleteMail', { fid: Number(fid), id: idList, _account: i, directDelete });
                    await mailApis.doDeleteMail({ fid: Number(fid), id: idList, _account: i, directDelete });
                    reqCount++;
                }
                catch (e) {
                    console.error('[deleteMailMultiAccount Error]', e);
                }
            }
            return {
                reqCount,
                accountCount: Object.keys(map).length,
                fid,
            };
        }
    },
    pending: (state, action) => {
        const params = action.meta.arg || {};
        const { fid } = params || {};
        const messageKey = fid + '';
        reduxMessage.loading({
            content: getIn18Text('YOUJIANSHANCHUZHONG'),
            duration: 3,
            key: messageKey,
        });
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const { reqCount, accountCount, fid } = action.payload;
        if (reqCount >= accountCount) {
            reduxMessage.success({
                content: `邮件删除成功`,
                duration: 1,
                key: fid + '',
            });
        }
        else if (reqCount == 0) {
            reduxMessage.error({
                content: `邮件删除失败`,
                duration: 2,
                key: fid + '',
            });
        }
        else {
            reduxMessage.warn({
                content: `邮件部分删除失败`,
                duration: 2,
                key: fid + '',
            });
        }
    },
});
thunkHelper({
    name: 'showDeleteMultiMailDialog',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { map, isScheduleSend = false } = params || {};
        const state = thunkAPI.getState().mailReducer;
        let mailNum = 0;
        if (map) {
            for (let i in map) {
                const idList = map[i];
                mailNum += idList.length;
            }
        }
        let content = isScheduleSend ? getIn18Text('SHANCHUYOUJIANHOU') : '';
        const deleteDialog = {
            danger: true,
            content,
            title: `确定删除${`选中的${mailNum}封`}邮件吗？`,
            okText: `删除`,
            onOk: () => {
                dispatch(MailActions.doUpdateCommonModalVisible(false));
                dispatch(Thunks.deleteMailMultiAccount(params));
            },
        };
        return deleteDialog;
    },
    fulfilled: (state, action) => {
        const deleteDialog = action.payload;
        state.dialogConfig = deleteDialog;
        state.commonModalVisible = true;
    },
});
thunkHelper({
    name: 'deleteMailReConfirm',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { id, isScheduleSend = false, realDeleteNum, folderId } = params || {};
        const state = thunkAPI.getState().mailReducer;
        const { selectedKeys, mailSearchStateMap } = state;
        const isSearching = getIsSearchingMailByState(state);
        const key = folderId ? folderId : selectedKeys.id;
        let isDeleted = key === 4;
        const mailCount = typeof id === 'string' ? 1 : id.length;
        const mailNum = getRealCountFromAvtiveMails({
            mailDataList: typeof id === 'string' ? [state.mailEntities[id]] : id.map(id => state.mailEntities[id]),
            isSearching,
            selectedKeysId: selectedKeys.id,
            selectedKeysAccountId: selectedKeys.accountId,
        });
        let content = isDeleted ? getIn18Text('CHEDISHANCHUDE') : isScheduleSend ? getIn18Text('SHANCHUYOUJIANHOU') : '';
        if (isSearching || key === FLOLDER.TAG || key === FLOLDER.REDFLAG) {
            isDeleted = false;
            if (realDeleteNum && realDeleteNum !== mailCount) {
                content = getIn18Text('QIZHONGFENGYISHANCDYJJCDSC', { realDeleteNum: realDeleteNum });
            }
        }
        const deleteStr = isDeleted ? getIn18Text('CHEDI') : '';
        let title = getIn18Text('QUEDINGSHANCHUGAIYJM', { deleteStr });
        if (Array.isArray(id)) {
            if (deleteStr) {
                title = getIn18Text('QUEDINGSHANCHUXUANZDFYJM？', { deleteStr, mailNum });
            }
            else {
                title = getIn18Text('QUEDINGSHANCHUXUANZDFYJM1', { mailNum });
            }
        }
        else {
            if (deleteStr) {
                title = getIn18Text('QUEDINGSHANCHUGAIYJM？', { deleteStr });
            }
            else {
                title = getIn18Text('QUEDINGSHANCHUGAIYJM？');
            }
        }
        const deleteDialog = {
            danger: true,
            content,
            title: title,
            okText: isDeleted ? getIn18Text('CHEDISHANCHU') : getIn18Text('SHANCHU'),
            onOk: () => {
                dispatch(MailActions.mailOperCheck(id));
                dispatch(Thunks.deleteMailNoConfirm(params));
            },
        };
        return deleteDialog;
    },
    fulfilled: (state, action) => {
        const deleteDialog = action.payload;
        state.dialogConfig = deleteDialog;
        state.commonModalVisible = true;
    },
});
thunkHelper({
    name: 'deleteMailFromHotKey',
    request: async (params, thunkAPI) => {
        var _a;
        const { dispatch, rejectWithValue } = thunkAPI;
        const id = params;
        const state = thunkAPI.getState().mailReducer;
        const { selectedKeys, mailEntities } = state;
        const key = selectedKeys.id;
        const isDeleted = key === 4;
        const idlist = typeof id === 'string' ? [id] : id;
        const mailList = ((_a = idlist.map(id => mailEntities[id])) === null || _a === void 0 ? void 0 : _a.filter(item => item)) || [];
        if (mailList.some(mail => mail.taskId && mail.taskInfo && mail.taskInfo.status === TASK_MAIL_STATUS.PROCESSING)) {
            reduxMessage.info({ content: getIn18Text('WEIWANCHENGDEREN') });
            return rejectWithValue();
        }
        if (typeof id === 'string' && !isDeleted) {
            mailApis.doDeleteMail({ fid: Number(selectedKeys.id), id, _account: getAccountByMailId(state, id) }).then(res => {
                reduxMessage.success({
                    content: `邮件删除成功`,
                    duration: 1,
                    key: id + '',
                });
            });
            setTimeout(() => {
                dispatch(MailListThunks.loadMailListIfNotFullScreen(id));
            }, 0);
            if (shouldSkipOpenNext(state.selectedKeys.id)) {
                return dispatch(MailActions.clearReadSelection(id));
            }
            return dispatch(MailActions.activeNextMailById(id));
        }
        dispatch(Thunks.deleteMail({ id }));
        return rejectWithValue();
    },
    fulfilled: (state, action) => {
        const id = action.meta.arg || '';
        const { selectedKeys, searchList, searchResultObj, mailDataList, mailTotal } = state;
        const isSearching = getIsSearchingMailByState(state);
        const key = selectedKeys ? selectedKeys.id : '';
        const isDeleted = key === 4;
        if (typeof id === 'string' && !isDeleted) {
            if (isSearching) {
                state.searchList = searchList.filter(mailId => mailId !== id);
                state.searchResultObj = Object.assign(Object.assign({}, searchResultObj), { total: searchResultObj.total - 1 });
            }
            else {
                state.mailDataList = mailDataList.filter(mailId => mailId !== id);
                state.mailTotal = mailTotal - 1;
            }
        }
    },
});
thunkHelper({
    name: 'doMoveMail',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue, getState } = thunkAPI;
        const { mailId, folderId, showLoading = true } = params;
        try {
            const state = getState().mailReducer;
            const res = await mailApis.doMoveMail(mailId, folderId, undefined, undefined, getAccountByMailId(state, mailId));
            if (res && res.succ) {
                return res;
            }
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    pending: (state, action) => {
        const { mailId, showLoading = true } = action.meta.arg;
        const messageKey = mailId.toString();
        if (showLoading) {
            reduxMessage.loading({
                content: getIn18Text('YOUJIANYIDONGZHONG'),
                duration: 35,
                key: messageKey,
            });
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg;
        const { mailId, showLoading = true } = params;
        const messageKey = mailId.toString();
        showLoading &&
            reduxMessage.success({
                content: getIn18Text('YOUJIANYIDONGCHENG'),
                duration: 1,
                key: messageKey,
            });
    },
    rejected: (state, action) => {
        const { mailId, showLoading = true } = action.meta.arg;
        const error = action.payload;
        const messageKey = mailId.toString();
        showLoading && reduxMessage.warn({ content: getIn18Text('YOUJIANYIDONGSHI'), duration: 1, key: messageKey });
        state.showGlobalLoading = false;
        console.warn(error);
    },
});
thunkHelper({
    name: 'doMoveMailFromModal',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { mfModalSelectedFids, mailMoveMid } = state;
        if (!mfModalSelectedFids) {
            reduxMessage.error({
                content: getIn18Text('QINGXUANZEYAOYI'),
            });
            return;
        }
        dispatch(Thunks.doMoveMail({
            mailId: mailMoveMid.mailId,
            folderId: mfModalSelectedFids[0],
            showLoading: true,
            accountId: mailMoveMid.accountId,
        }));
    },
    fulfilled: (state) => {
        state.mailMoveModalVisiable = false;
    },
});
thunkHelper({
    name: 'syncMailTop',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        dispatch(MailListThunks.refreshMailList({
            showLoading: false,
            toTop: false,
        }));
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg;
        const { eventData, eventStrData, _account } = params;
        if (eventData.status === 'success' || eventData.status === 'fail') {
            reducerHelper.updateMailEntity(state.mailEntities, 'top', eventData.result);
        }
    },
});
thunkHelper({
    name: 'syncMailDeleted',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { eventData, eventStrData, _account } = params;
        const { selectedKeys } = state;
        const isSearching = getIsSearchingMailByState(state);
        const isUseRealList = getIsUseRealList(state);
        if (eventData.status === 'success' && eventData.result && _account == selectedKeys.accountId) {
            const mailIds = eventData.params.id;
            setTimeout(() => {
                dispatch(MailListThunks.loadMailListIfNotFullScreen({
                    mailIds,
                    ids: isUseRealList ? mailIds : [],
                    accountId: _account,
                }));
            }, 0);
            if (state.configMailLayout != '2') {
                if (shouldSkipOpenNext(state.selectedKeys.id)) {
                    dispatch(MailActions.clearReadSelection(mailIds));
                }
                else {
                    dispatch(MailActions.activeNextMailById(mailIds));
                }
            }
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const { eventData, _account } = params;
        if (eventData.status === 'success') {
            const mailIds = Array.isArray(eventData.params.id) ? eventData.params.id : [eventData.params.id];
            const { searchList, searchResultObj, mailDataList, mailTotal } = state;
            const idLen = mailIds.length;
            state.searchList = searchList.filter(mailId => {
                return mailIds.indexOf(mailId) < 0;
            });
            state.searchResultObj = Object.assign(Object.assign({}, searchResultObj), { total: searchResultObj.total - idLen });
            if (!state.useRealList) {
                state.mailDataList = mailDataList.filter(mailId => {
                    return (mailIds === null || mailIds === void 0 ? void 0 : mailIds.indexOf(mailId)) < 0;
                });
            }
            for (let key in state.customer) {
                if (state.customer[key]) {
                    const { mailDataList, mailTotal } = state.customer[key];
                    state.customer[key].mailDataList = mailDataList === null || mailDataList === void 0 ? void 0 : mailDataList.filter(mailId => {
                        return (mailIds === null || mailIds === void 0 ? void 0 : mailIds.indexOf(mailId)) < 0;
                    });
                    state.customer[key].mailTotal = mailTotal - idLen;
                }
            }
            state.mailTotal = mailTotal - idLen;
            state.readMailChildMailList = state.readMailChildMailList.filter(id => (mailIds === null || mailIds === void 0 ? void 0 : mailIds.indexOf(id)) < 0);
            if (mailIds === null || mailIds === void 0 ? void 0 : mailIds.includes(state.readMailWindowActiveMailId)) {
                state.readMailWindowActiveMailId = null;
            }
            if (mailIds === null || mailIds === void 0 ? void 0 : mailIds.includes(state.mailRelateActiveMialId)) {
                state.mailRelateActiveMialId = null;
            }
            if (mailIds.some((item) => state.mailRelateMailList.includes(item))) {
                state.mailRelateMailList = state.mailRelateMailList.filter(item => !mailIds.includes(item));
            }
            if (mailIds === null || mailIds === void 0 ? void 0 : mailIds.includes(state.mailRelateStrangerActiveId)) {
                state.mailRelateStrangerActiveId = '';
            }
            if (mailIds.some((item) => state.mailRelateStrangeMailList.includes(item))) {
                state.mailRelateStrangeMailList = state.mailRelateStrangeMailList.filter(item => !mailIds.includes(item));
            }
        }
    },
});
thunkHelper({
    name: 'syncMailMove',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { eventData, eventStrData, _account } = params;
        const isSearching = getIsSearchingMailByState(state);
        const isUseRealList = state.useRealList && !isSearching;
        if (eventData.status === 'success' && _account == state.selectedKeys.accountId) {
            const { id, fid } = (eventData === null || eventData === void 0 ? void 0 : eventData.params) || {};
            if (id && fid) {
                if (fid !== state.selectedKeys.id) {
                    if (!isUseRealList) {
                        setTimeout(() => {
                            dispatch(MailListThunks.loadMailListIfNotFullScreen(id));
                        }, 0);
                    }
                    else {
                        setTimeout(() => {
                            dispatch(MailListThunks.loadMailListIfNotFullScreen({ ids: Array.isArray(id) ? id : [id] }));
                        }, 0);
                    }
                    if (shouldSkipOpenNext(state.selectedKeys.id)) {
                        dispatch(MailActions.clearReadSelection(id));
                    }
                    else {
                        dispatch(MailActions.activeNextMailById(id));
                    }
                }
            }
        }
    },
    fulfilled: (state, action) => {
        const params = action.meta.arg || {};
        const { eventData } = params;
        const { mailDataList } = state;
        if ((eventData === null || eventData === void 0 ? void 0 : eventData.status) === 'success' || (eventData === null || eventData === void 0 ? void 0 : eventData.status) === 'fail') {
            const { id, fid } = (eventData === null || eventData === void 0 ? void 0 : eventData.params) || {};
            if (id) {
                const mailId = Array.isArray(id) ? id : [id];
                const isSearching = getIsSearchingMailByState(state);
                const isUseRealList = state.useRealList && !isSearching;
                if (isUseRealList) {
                    state.mailTotal = state.mailTotal - mailId.length;
                }
                mailId.forEach(item => {
                    const mail = state.mailEntities[item];
                    if (mail) {
                        mail.entry.folder = fid;
                    }
                });
                if (fid !== state.selectedKeys.id) {
                    state.mailDataList = mailDataList.filter(item => {
                        return (mailId === null || mailId === void 0 ? void 0 : mailId.indexOf(item)) < 0;
                    });
                }
            }
        }
    },
});
thunkHelper({
    name: 'syncMailTagOper',
    request: async (param, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { type, params, _account } = param;
        if (type == 'add') {
            dispatch(MailBoxThunks.requestTaglist({ account: _account }));
        }
    },
    fulfilled: (state, action) => {
        var _a;
        const param = action.meta.arg || {};
        const { type, params, _account } = param;
        if (type == 'delete') {
            if (params && params.length) {
                const tagName = params[0];
                const { mailTagFolderActiveKey, selectedKeys } = state;
                if (selectedKeys.id === FLOLDER.TAG && tagName === (mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key)) {
                    state.selectedKeys = Object.assign(Object.assign({}, state.selectedKeys), { id: FLOLDER.DEFAULT });
                }
                if (tagName === null || tagName === void 0 ? void 0 : tagName.key) {
                    for (let mail of Object.values(state.mailEntities)) {
                        if (mail && mail.tags && _account == (mail === null || mail === void 0 ? void 0 : mail._account)) {
                            mail.tags = mail.tags.filter((t) => t != (tagName === null || tagName === void 0 ? void 0 : tagName.key));
                        }
                    }
                }
            }
        }
        else if (type == 'replace' || type == 'update') {
            const tagName = params[0];
            const alias = (_a = params[1]) === null || _a === void 0 ? void 0 : _a.alias;
            if (tagName && alias) {
                for (let mail of Object.values(state.mailEntities)) {
                    if (mail && mail.tags && _account == (mail === null || mail === void 0 ? void 0 : mail._account)) {
                        mail.tags = mail.tags.map((tag) => {
                            if (tag === tagName) {
                                return alias;
                            }
                            return tag;
                        });
                    }
                }
            }
        }
    },
});
thunkHelper({
    name: 'markProcessFollow',
    request: async (param, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        const { ids = [], mark, showMessage = true, accounts = [] } = param;
        const res = await mailPlusCustomerApi.doSetProcessedOfFollow(ids, accounts, !!mark);
        return res;
    },
    fulfilled: (state, action) => {
        const param = action.meta.arg || {};
        const { ids, mark, showMessage = true } = param;
        if (ids && ids.length) {
            try {
                const mails = getMailListByIdFromStore(ids, state.mailEntities);
                if (mails && mails.length) {
                    mails.forEach(mail => {
                        mail.entry.isFollowUp = !!mark;
                    });
                }
            }
            catch (e) {
                console.error('[Error getMailListByIdFromStore]', e);
            }
        }
        showMessage && reduxMessage.success({ content: mark ? getIn18Text('YOUJIANGENJWC') : getIn18Text('BIAOWEIDAIGJCG') });
    },
    rejected: (state, action) => {
        const param = action.meta.arg || {};
        const { ids, mark, showMessage = true } = param;
        showMessage && reduxMessage.error({ content: mark ? '标为已跟进失败' : '标为待跟进失败' });
    },
});
export const mailManageThunks = Thunks;
export const mailManageReducersList = ReducersList;
